import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current: 0,
};

const currentSlice = createSlice({
  name: 'current',
  initialState,
  reducers: {
    setUpdate(state, action) {
      const { payload } = action;
      state.current = payload;
    },
    clearCurrent(state) {
      state.current = initialState.current;
    },
  },
});

export const { setUpdate, clearCurrent } = currentSlice.actions;
export default currentSlice.reducer;
